<script>
import _ from 'lodash'
import FollowupRecordGradeService from '@/request/followup/followupRecordGrade'
export default {
  name: 'FollowupRecord',
  components: {},
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      followupRecordGrade: {}
    }
  },
  computed: {},
  created: function () {
    if (!_.isEmpty(this.data)) {
      this.listFollowupRecordGrade()
    }
  },
  watch: {
    data () {
      this.listFollowupRecordGrade()
    }
  },
  methods: {
    listFollowupRecordGrade () {
      let self = this
      if (!self.data || !self.data.id) {
        self.followupRecordGrade = {}
        return
      }
      FollowupRecordGradeService.list({
        record: self.data.id
      }).then(data => {
        data = data.result
        if (_.isEmpty(data)) {
          self.followupRecordGrade = {}
          return
        }
        _.forEach(data, value => {
          let grades = self.followupRecordGrade['grades']
          let gnames = self.followupRecordGrade['gnames']
          if (!grades) {
            grades = []
          }
          if (!gnames) {
            gnames = []
          }
          if (_.findIndex(grades, function (o) { return o.id === value.id }) < 0) {
            grades.push(value)
          }
          if (_.indexOf(gnames, value.gname) < 0) {
            gnames.push(value.gname)
          }
          self.$set(self.followupRecordGrade, 'grades', _.cloneDeep(grades))
          self.$set(self.followupRecordGrade, 'gnames', _.cloneDeep(gnames))
        })
      })
    }
  },
  filters: {
    formatFollowupGrade (value) {
      let result = '未知'
      switch (value) {
        case 1:
          result = '良好'
          break
        case 2:
          result = '一般'
          break
        case 3:
          result = '不良'
          break
      }
      return result
    },
    filterTime (value) {
      if (!value) {
        return '未知时间'
      }
      if (Object.prototype.toString.call(value) === '[object String]') {
        return value
      }
      if (value === '' || isNaN(value)) {
        return '未知时间'
      }
      if (value <= 0) {
        return '未知时间'
      }
      if (value < 10000000000) {
        value *= 1000
      }
      let time = new Date(value)
      let tY = time.getFullYear()
      let tM = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1
      let tD = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
      let th = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
      let tm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
      let ts = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()
      let now = new Date()
      let nY = now.getFullYear()
      let nM = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
      let nD = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
      let result = ''
      if (tY !== nY) {
        result += tY + '年'
      }
      if (tM !== nM || tD !== nD) {
        result += tM + '月'
        result += tD + '日'
      }
      if (result === '') {
        result = th + ':' + tm + ':' + ts
      }
      return result
    }
  }
}
</script>

<template>
  <div class="record-wrap">
    <div class="record-content">
      <p v-if="!!data.content">{{data.content}}</p>
      <slot></slot>
    </div>
    <el-form class="grade-wrap" label-position="left" v-if="!!followupRecordGrade['grades'] && followupRecordGrade['grades'].length > 0">
      <el-form-item :label="gname" v-for="gname in followupRecordGrade['gnames']" :key="gname" style="margin-bottom: 0;">
        <template v-for="grade in followupRecordGrade['grades']">
          <span v-if="grade.gname === gname" :key="grade.id" class="frgrade-item">
            <span>{{grade.pname}}</span>
            <span class="frgrade-grade" :class="{warning: grade.grade === 2, danger: grade.grade === 3}">{{grade.grade | formatFollowupGrade}}</span>
          </span>
        </template>
      </el-form-item>
    </el-form>
    <div class="record-registrar-wrap inline-block">
      <span class="inline-block">
        <span> — </span>
        <span class="record-registrar">{{data.registrar}}</span>
        <span class="record-date">  ·  {{data.time | filterTime}}</span>
      </span>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.record-wrap {
  margin-top: 10px;
  padding-bottom: 10px;
  font-size: 13px;
  background-color: #FAFAFA;
  padding: 10px;
  position: relative;
  display: inline-block;
  color: #666;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.record-content {
  line-height: 1.6;
  word-wrap: break-word;
  margin-bottom: 10px !important;
}
.grade-wrap {
  width: 400px;
}
.frgrade-item {
  padding: 0 10px;
}
.frgrade-item .frgrade-grade {
  color: #67C23A;
}
.frgrade-item .frgrade-grade.warning {
  color: #E6A23C;
}
.frgrade-item .frgrade-grade.danger {
  color: #F56C6C;
}
.record-registrar-wrap {
  color: #999;
}
.record-registrar {
  color: #409EFF;
}
.inline-block {
  display: inline-block;
}
</style>
